import { createSlice } from "@reduxjs/toolkit";
import customerSlice from "../customer/customerSlice";

const initialState = {
  videoText:
    "För att vi ska kunna ge dig en tydlig och korrekt offert för din webbplats, SEO-optimering, eller digitala marknadsföringstjänster, erbjuder vi ett kostnadsfritt rådgivningsmöte.",
};

const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    setMainQuery: (state, { payload }) => {
      state.mainQuery = payload;
    },
  },
});

export const { setMainQuery } = contentSlice.actions;
export const getContentData = (state) => state.content;
export default contentSlice.reducer;
